import { ChevronDown } from "@lazarentertainment/web-design-system/components/iconOutline"
import { Button } from "client/designSystem/Button"
import { useGlobalContext } from "client/packages/utils/GlobalContext"

export const LightboxDismissButton = () => {
  const { setLightboxContent } = useGlobalContext()

  const closeLightbox = () => {
    setLightboxContent({ contentType: "none" })
  }

  return (
    <Button
      variant="overlay"
      size="md"
      icon={ChevronDown}
      onClick={closeLightbox}
    />
  )
}
